import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background-50 px-4 text-center">
      <div className="flex items-center gap-2.5">
        <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-600 text-background-50">
          <i className="ri-film-line text-xl" />
        </span>
        <span className="text-lg font-bold text-foreground-950">肮脏的交易</span>
      </div>
      <p className="mt-8 text-6xl font-black text-background-300 md:text-8xl">404</p>
      <h1 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">
        找不到这个页面了
      </h1>
      <p className="mt-3 text-sm text-foreground-500">
        页面 <span className="text-foreground-700">{location.pathname}</span> 可能已被移除或链接有误。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          去搜索影视
        </Link>
      </div>
    </div>
  );
}